/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import CenterChart from "../../components/CenterChart";
import BarWidgetRadialPanels from "../../widgets/BarWidget/BarWidgetRadialPanels";

const ExploreRoom = () => {
    return (
        <a-entity class="Explore Room">
            <a-entity
                position="0 0 -5"
                animation__position="property:position; to: 0 0.25 -5;autoplay:true; dur:2000"
                animation__scale="property:scale; to: 1.5 1.5 1.5;autoplay:true; dur:2000"
            >
                <CenterChart width="4" height="2" depth="2" />
                <BarWidgetRadialPanels width={4} height={2} stateName="centerGraph" />
            </a-entity>
        </a-entity>
    );
};

export default ExploreRoom;
